//
// LayoutGlobalLegend.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/RendererModel";
import "./Legend";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "../core/HorizontalAlignment";
import "../core/VerticalAlignment";
import "./LegendTitlePosition";
import "./LegendPosition";
import "../core/Pad";
import "./GlobalLegendType";
import "./GlobalLegendVisibility";
import "./GlobalLegendWeightType";
import "../core/styles/FillAttributes";
import "../core/styles/LineAttributes";
import "../core/styles/TextAttributes";

var LayoutGlobalLegend = createModule("gtl::LayoutGlobalLegend", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel"], EventDispatcher, [
    ,
    {
        border: 2,
        titleAttributes: 1,
        hAlign: 4,
        visible: 4,
        outerPad: 1,
        title: 7,
        type: 4,
        backgroundAttributes: 1,
        vAlign: 4,
        gutter: 1,
        weightType: 4,
        pad: 1,
        legends: [1],
        legendTitlePosition: 4,
        borderAttributes: 1,
        legendPosition: 4,
        allowCollapsed: 2,
        allowCollapsedInteraction: 2,
        weightsList: [6],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default LayoutGlobalLegend;
